module.exports = __webpack_public_path__ + "img/Frame 8.47bcb5d3.svg";